import cjsModule from '../index.js';
export const transpose = cjsModule.transpose; 
export const Chord = cjsModule.Chord; 
export const KeySignature = cjsModule.KeySignature; 
export const KeySignatures = cjsModule.KeySignatures; 
export const Transposer = cjsModule.Transposer; 